export default function() {
    const self = this

    self.showCloningAlert = self.$route.name === 'ContractorCloneEventForm'

    if (self.isCloning) {
      self.$store.state.creatingEvent = self.$route.params.id
    }

    if (self.$route.params.id) {
        const eventId = self.$route.params.id

        self.loadEvent(eventId)
            .then(event => {
                if (self.$route.params.id) {
                    self.event = event
                    self.jobDetails.foodIncluded = event.foodIncluded ?? false
                    self.jobDetails.uniformIncluded = event.uniformIncluded ?? false
                    self.jobDetails.socialClothing = event.socialClothing ?? false
                    self.jobDetails.uniformDetails = event.uniformDetails ?? ''

                    let profileSearchArr = []
                    event.profileSearches.forEach(profile => {
                        profile.profiles = event.jobs.filter(job => {
                          return job.profileSearch.id === profile.id && ([0,1].includes(job.status) || !job.status)
                        }).map(job => {
                          return job.workProfile
                        })

                        self.updateJobTypeOptions(profile)
                        profileSearchArr[profile.id] = profile
                    })

                    if (event.jobs?.length && !self.$store.state.jobsSynced || self.isCloning) {
                      self.$store.commit('updateProfileSearches', profileSearchArr)
                      self.$store.state.jobsSynced = true
                    }

                    // Load draft selections if the event is still being created and has no committed jobs
                    if (event.status === 'creating' && !event.jobs?.length) {
                        self.loadDraftSelections(eventId, profileSearchArr)
                    }

                    self.event = event
                    self.oneDayEvent = event.totalDays === 1

                    if (self.oneDayEvent) {
                        self.event.dates.push({
                          startDate: null,
                          endDate: null,
                          startTime: null,
                          endTime: null,
                          start: null,
                          end: null,
                          displayDate: null
                        })
                    }
                    if (!event.profileSearches.length) {
                        self.appendProfileSearch()
                    }
                    return
                }

                const today = new Date(),
                    eventDate = new Date(event.start)

                if (today < eventDate && event.status === 'creating') {

                    event.profileSearches.forEach(profile => {
                        self.updateJobTypeOptions(profile)
                    })

                    self.event = event
                    self.$router.push({
                        name: self.isCloning ? 'ContractorCloneEventForm' : 'ContractorEventForm',
                        params: {
                            id: eventId
                        }
                    })
                } else {
                    self.$store.commit('resetProfileFinder')
                }
            })
            .catch(() => {
                self.$store.commit('resetProfileFinder')
            })
    } else if (self.$route.params.id) {
        const eventId = self.$route.params.id

        self.loadEvent(eventId)
            .then(event => {
                if (!event.profileSearches.length) {
                    self.appendProfileSearch()
                }

                event.profileSearches.forEach(profile => {
                    self.updateJobTypeOptions(profile)
                })

                self.event = event
                self.oneDayEvent = event.totalDays === 1

                if (self.oneDayEvent) {
                    self.event.dates.push({
                        startDate: null,
                        endDate: null,
                        startTime: null,
                        endTime: null,
                        start: null,
                        end: null,
                        displayDate: null
                    })
                }
            })
            .catch(() => {
                self.$store.commit('resetProfileFinder')
            })
    } else {
        self.$store.commit('resetProfileFinder')
    }
}
